import React from 'react';
import {Table, Loader} from 'semantic-ui-react';

export const renderTableLoader = () => {
  return (
    <Table>
      <Table.Body>
        <Table.Row className='loader'>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
};
